/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions

  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import firebase from 'firebase/app'
import 'firebase/auth'
import trackAnalytics from '@/helpers/trackAnalytics'

export default (ctx) => ({
  loginAttempt ({ dispatch }, payload) {

    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    }

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {

      // Change firebase Persistence
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

      // If success try to login
        .then(function () {
          dispatch('login', newPayload)
        })

      // If error notify
        .catch(function (err) {

          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation()

          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    } else {
      // Try to login
      dispatch('login', newPayload)
    }
  },
  login ({ state, dispatch }, payload) {

    console.log('login action', payload)

    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title: 'Login',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })

      return false
    }

    // Try to sigin

    firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)

      .then((result) => {
        trackAnalytics(null, 'login', 'success', 'Login e-mail & password')

        // Set FLAG username update required for updating username
        let isUsernameUpdateRequired = false

        // if username is provided and updateUsername FLAG is true
        // set local username update FLAG to true
        // try to update username
        if (payload.updateUsername && payload.userDetails.displayName) {

          isUsernameUpdateRequired = true

          dispatch('updateUsername', {
            user: result.user,
            displayName: payload.userDetails.displayName,
            notify: payload.notify,
            isReloadRequired: true,
            isAnonymous: false
          })
        }

        // Close animation if passed as payload
        if (payload.closeAnimation) payload.closeAnimation()

        // if username update is not required
        // just reload the page to get fresh data
        // set new user data in localstorage
        if (!isUsernameUpdateRequired) {
          ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })

          dispatch('updateUserInfo', {...result.user.providerData[0], isAnonymous: false}, { root: true })
        }
      }, (err) => {

        // Close animation if passed as payload
        if (payload.closeAnimation) payload.closeAnimation()

        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  // Google Login
  loginWithGoogle ({ state, dispatch }, payload) {
    const provider = new firebase.auth.GoogleAuthProvider()

    if (firebase.auth().currentUser) {
        firebase.auth().currentUser.linkWithPopup(provider)
          .then((result) => {
            ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
            dispatch('updateUserInfo', {...result.user.providerData[0], isAnonymous: false}, { root: true })
            trackAnalytics(null, 'register', 'success', 'Login Google')
          }).catch((err) => {
            payload.notify({
              time: 2500,
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })

    } else {
      firebase.auth().signInWithPopup(provider)
        .then((result) => {
          ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
          dispatch('updateUserInfo', {...result.user.providerData[0], isAnonymous: false}, { root: true })
          trackAnalytics(null, 'register', 'success', 'Google')
        }).catch((err) => {
          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      )
    }
  },

  // Facebook Login
  loginWithFacebook ({ state, dispatch }, payload) {
    const provider = new firebase.auth.FacebookAuthProvider()

    if (firebase.auth().currentUser) {
      firebase.auth().currentUser.linkWithPopup(provider)
        .then((result) => {
          ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
          dispatch('updateUserInfo', {...result.user.providerData[0], isAnonymous: false}, { root: true })
          trackAnalytics(null, 'login', 'success', 'Login Facebook')
        }).catch((err) => {
          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    } else {
      firebase.auth().signInWithPopup(provider)
      .then((result) => {
        ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
        dispatch('updateUserInfo', {...result.user.providerData[0], isAnonymous: false}, { root: true })
        trackAnalytics(null, 'login', 'success', 'Login Facebook')
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    }
  },

  loginAnonymous ({ state, dispatch }, payload) {
    firebase.auth().signInAnonymously()
      .then((result) => {
             const channel = ctx.router.currentRoute.query.channel || ''
        const adgroup = ctx.router.currentRoute.query.adgroup || ''
        const creative = ctx.router.currentRoute.query.creative || ''
        const campaign = ctx.router.currentRoute.query.campaign || ''
        const keyword = ctx.router.currentRoute.query.keyword || ''
        const inviter = ctx.router.currentRoute.query.inviter || ''
        const gclid = ctx.router.currentRoute.query.gclid || ''
        const msclkid = ctx.router.currentRoute.query.msclkid || ''
        const onboardingFinished = ctx.router.currentRoute.query.onboardingFinished || ''
        const whatAreYouTryingToSolve = ctx.router.currentRoute.query.whatAreYouTryingToSolve || ''

        const positive = ctx.router.currentRoute.query.positive || ''
        const negative = ctx.router.currentRoute.query.negative || ''
        const iAmAge = ctx.router.currentRoute.query.iAmAge || ''
        const iAmOccup = ctx.router.currentRoute.query.iAmOccup || ''

        const onboardingPath = ctx.router.currentRoute.query.onboardingPath || ''
        const isAnonymous = result.user.isAnonymous

        // debugger
        console.log("ctx.router.currentRoute.query", ctx.router.currentRoute.query)
        console.log("onboardingFinished", ctx.router.currentRoute.onboardingFinished)

        dispatch('updateUserInfo', { isAnonymous, adgroup, creative, campaign, channel, keyword, inviter, onboardingPath, onboardingFinished, whatAreYouTryingToSolve, positive, negative, iAmAge, iAmOccup, gclid, msclkid }, { root: true }).then(() => {
          ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
        })
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage)
        // ...
      })
  },
  // Twitter Login
  // loginWithTwitter ({commit, state}, payload) {
  //   if (state.isUserLoggedIn()) {
  //     payload.notify({
  //       title: 'Login',
  //       text: 'You are already logged in!',
  //       iconPack: 'feather',
  //       icon: 'icon-alert-circle',
  //       color: 'success'
  //     })
  //     return false
  //   }
  //   const provider = new firebase.auth.TwitterAuthProvider()
  //
  //   firebase.auth().signInWithPopup(provider)
  //     .then((result) => {
  //       ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
  //       dispatch('updateUserInfo', result.user.providerData[0], { root: true })
  //     }).catch((err) => {
  //       payload.notify({
  //         time: 2500,
  //         title: 'Error',
  //         text: err.message,
  //         iconPack: 'feather',
  //         icon: 'icon-alert-circle',
  //         color: 'danger'
  //       })
  //     })
  // },

  // Github Login
  // loginWithGithub ({commit, state}, payload) {
  //   if (state.isUserLoggedIn()) {
  //     payload.notify({
  //       title: 'Login',
  //       text: 'You are already logged in!',
  //       iconPack: 'feather',
  //       icon: 'icon-alert-circle',
  //       color: 'success'
  //     })
  //     return false
  //   }
  //   const provider = new firebase.auth.GithubAuthProvider()
  //
  //   firebase.auth().signInWithPopup(provider)
  //     .then((result) => {
  //       ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
  //       dispatch('updateUserInfo', result.user.providerData[0], { root: true })
  //     }).catch((err) => {
  //       payload.notify({
  //         time: 2500,
  //         title: 'Error',
  //         text: err.message,
  //         iconPack: 'feather',
  //         icon: 'icon-alert-circle',
  //         color: 'danger'
  //       })
  //     })
  // },

  registerUser ({dispatch, getters, state }, payload) {
    const displayName = payload.userDetails.displayName

    if (firebase.auth().currentUser) {
      const credential = firebase.auth.EmailAuthProvider.credential(payload.userDetails.email, payload.userDetails.password)
      firebase.auth().currentUser.linkWithCredential(credential)
      .then((result) => {

        const email = payload.userDetails.email
        const isAnonymous = false

        payload.notify({
          title: `Hello, ${displayName}!`,
          text: 'Good luck on your journey.',
          iconPack: 'feather',
          icon: 'icon-user-check',
          color: 'dark'
          })

        ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
        dispatch('updateUserInfo', { isAnonymous, displayName, email}, { root: true })
        // trackAnalytics(null, 'register', 'success', 'Google')

      }, (error) => {
        payload.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    } else {
      firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
        .then(() => {
          payload.notify({
            title: `Hello, ${displayName}!`,
            text: 'Good luck on your journey.',
            iconPack: 'feather',
            icon: 'icon-user-check',
            color: 'dark'
          })

          const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            updateUsername: true
          }

          trackAnalytics(null, 'register', 'success', 'Register e-mail & password')
          dispatch('login', newPayload)

      }, (error) => {
        payload.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    }

  },
  updateUsername ({ dispatch }, payload) {
    payload.user.updateProfile({
      displayName: payload.displayName
    }).then(() => {

      // If username update is success
      // update in localstorage
      const newUserData = Object.assign({}, payload.user.providerData[0])
      newUserData.displayName = payload.displayName
      dispatch('updateUserInfo', newUserData, { root: true })

      // If reload is required to get fresh data after update
      // Reload current page
      if (payload.isReloadRequired) {
        ctx.router.replace(ctx.router.currentRoute.query.to || { name: 'planner' })
      }
    }).catch((err) => {
      payload.notify({
        time: 8800,
        title: 'Error',
        text: err.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })
  },
})
